import React from 'react';
import CheckboxControl from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';

const Label = ({ children, labelTextClassName }) => (
  <span className={labelTextClassName} style={{ fontSize: '1rem' }}>
    {children}
  </span>
);

const Checkbox = ({
  label,
  labelTextClassName,
  style,
  disabled,
  required,
  children,
  checkboxColor = 'primary',
  ...props
}) => (
  <FormControlLabel
    label={
      (label || children) && (
        <Label labelTextClassName={labelTextClassName}>
          {label || children}
        </Label>
      )
    }
    control={
      <CheckboxControl
        style={style}
        disabled={disabled}
        required={required}
        color={checkboxColor}
      />
    }
    {...props}
  />
);

export default Checkbox;
